// extracted by mini-css-extract-plugin
export default {"TableContainer":"PurchaseIntentList_TableContainer__X5PpB","Menu":"PurchaseIntentList_Menu__8gxgo"};